"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var ajax_1 = require("rxjs/ajax");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Simulator = /** @class */ (function () {
    function Simulator() {
    }
    Simulator.prototype.onLoad = function ($element) {
        // Final values to update
        this.$totaleVersatoNode = this.$element.$(".totale-versato");
        this.$risultatoPrevistoNode = this.$element.$(".risultato-previsto");
        // Simulator inputs
        this.$initialCapitalInput = this.$element.$("#initialCapital");
        this.$monthlyDepositInput = this.$element.$("#monthlyDeposit");
        this.$inputFunds = this.$element.$$('input[name="fund"]');
        this.$inputYears = this.$element.$$('input[name="numberOfMonths"]');
        this.$fundNameNode = this.$element.$(".titolo-fondo");
        // Initial values
        this.initialCapital = this.$initialCapitalInput.value;
        this.monthlyDeposit = this.$monthlyDepositInput.value;
        this.numberOfMonths = this.$inputYears
            .map(function (input) { return (input.checked ? input.value : null); })
            .filter(Boolean)[0];
        this.fund = this.$inputFunds
            .map(function (input) { return (input.checked ? input.dataset.endpointUrl : null); })
            .filter(Boolean)[0];
        this.getValuesFromRangeInput();
        this.getValuesFromRadioInput();
        this.fetchData(); // Disable this for testing
    };
    /* UTILITIES */
    Simulator.prototype.fetchData = function () {
        var _this = this;
        var _a;
        (0, ajax_1.ajax)({
            url: "".concat(this.fund, "?numeroMesi=").concat((_a = this.numberOfMonths) !== null && _a !== void 0 ? _a : "12"),
            method: "GET"
        })
            .pipe((0, operators_1.tap)(function () { return _this.$element.classList.add("--loading"); }), (0, operators_1.map)(function (_a) {
            var response = _a.response, status = _a.status;
            if (status !== 200)
                throw new Error("Chiamata andata in errore");
            return _this.extractDataFromFetch(response);
        }), (0, operators_1.tap)(function (_a) {
            var productName = _a.productName;
            return _this.updateSimulatorName(productName);
        }), (0, operators_1.catchError)(function (error) { return (0, rxjs_1.of)(error.status); }), (0, operators_1.tap)(function () { return _this.$element.classList.remove("--loading"); }), (0, operators_1.filter)(function (val) { return !!(val === null || val === void 0 ? void 0 : val.monthVariation); }))
            .subscribe(function (_a) {
            var monthVariation = _a.monthVariation;
            _this.monthVariation = monthVariation;
            _this.calculateSimulation();
        });
    };
    Simulator.prototype.extractDataFromFetch = function (response) {
        var productHistoryHalfMonth = response.productHistoryHalfMonth, productName = response.productName;
        var formattedData = Object.entries(productHistoryHalfMonth)
            .map(function (_a) {
            var date = _a[0], value = _a[1];
            return ({ date: date, value: value });
        })
            .flat();
        if (!(formattedData === null || formattedData === void 0 ? void 0 : formattedData.length))
            return { monthVariation: 0.000001, productName: productName };
        var valueOfFirst = formattedData[0].value, others = formattedData.slice(1);
        var valueOfLast = others.slice(-1)[0].value;
        var monthVariation = ((valueOfLast - valueOfFirst) / formattedData.length / valueOfFirst) *
            100;
        this.fundName = productName;
        return { monthVariation: monthVariation, productName: productName };
    };
    Simulator.prototype.calculateSimulation = function () {
        var _this = this;
        var moneyInvested = __spreadArray([
            Number(this.initialCapital)
        ], Array.from({ length: Number(this.numberOfMonths) }, function () {
            return Number(_this.monthlyDeposit);
        }), true);
        var moneyInvestedWithInterest = moneyInvested.map(function (value, index, _a) {
            var totalMonths = _a.length;
            return (value * ((100 + (totalMonths - index) * _this.monthVariation) / 100));
        });
        var total = moneyInvested.reduce(function (acc, value) { return acc + value; }, 0);
        var result = moneyInvestedWithInterest.reduce(function (acc, value) { return acc + value; }, 0);
        this.updateSimulatorTotal(total, result);
    };
    Simulator.prototype.updateSimulatorTotal = function (total, result) {
        var formatNumber = function (num) { return new Intl.NumberFormat("it-IT").format(num); };
        this.$risultatoPrevistoNode.innerHTML = "\u20AC ".concat(formatNumber(result));
        this.$totaleVersatoNode.innerHTML = "\u20AC ".concat(formatNumber(total));
    };
    Simulator.prototype.updateSimulatorName = function (name) {
        if (!(this.$fundNameNode && (name === null || name === void 0 ? void 0 : name.length)))
            return;
        this.$fundNameNode.innerHTML = "Fondo: ".concat(this.fundName);
    };
    Simulator.prototype.getValuesFromRangeInput = function () {
        var _this = this;
        if (this.$initialCapitalInput && this.$monthlyDepositInput) {
            [this.$initialCapitalInput, this.$monthlyDepositInput].forEach(function (input) {
                return (0, rxjs_1.fromEvent)(input, "input").subscribe(function (e) {
                    var _a = e.target, id = _a.id, value = _a.value;
                    _this[id] = value;
                    _this.calculateSimulation();
                });
            });
        }
    };
    Simulator.prototype.getValuesFromRadioInput = function () {
        var _this = this;
        this.$inputFunds.concat(this.$inputYears).forEach(function (input) {
            return (0, rxjs_1.fromEvent)(input, "change").subscribe(function (e) {
                var _a = e.target, name = _a.name, value = _a.value, dataset = _a.dataset;
                _this[name] = name === "numberOfMonths" ? value : dataset.endpointUrl;
                _this.fetchData();
            });
        });
    };
    Simulator = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".SimulatorSection",
            isElementArray: false
        })
    ], Simulator);
    return Simulator;
}());
new Simulator();
